<header>
    <div id="left-side">
        <img src="assets/icons/covid.svg" alt="Ilustração de um vírus">
        <h1>Dashboard - Brasil</h1>
    </div>
    <div id="right-side">
        <button *ngIf="!currentUrl" routerLink="/brazil" class="btn btn-inverted">Voltar para o início</button>
        <button routerLink="/world" class="btn">Ver os dados do mundo</button>
    </div>
</header>